import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const BlogNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '關於我們', href: '/#about' },
    { label: '服務項目', href: '/#services' },
    { label: '最新消息', href: '/blog' },
    { label: '聯絡我們', href: '/#contact' },
  ];

  const handleNavClick = (href: string) => {
    if (href.startsWith('/#')) {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(href.replace('/', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      navigate(href);
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/299aafac10f17bf7dd171fda07c097c7.png" 
              alt="前金日間照顧中心" 
              className="w-12 h-12 object-contain"
            />
            <span className="text-lg font-bold text-baby-blue-600">前金日間照顧中心</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavClick(item.href)}
                className="text-sm font-medium text-baby-blue-600 hover:text-baby-blue-400 transition-colors cursor-pointer"
              >
                {item.label}
              </button>
            ))}
          </div>

          <button
            onClick={() => handleNavClick('/#contact')}
            className="hidden md:flex items-center gap-2 bg-cream-300 hover:bg-cream-400 text-baby-blue-600 px-5 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            立即諮詢
          </button>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-2xl text-baby-blue-600 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 bg-white rounded-2xl shadow-lg p-4">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavClick(item.href)}
                className="block w-full text-left px-4 py-3 text-baby-blue-600 hover:bg-baby-blue-50 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => handleNavClick('/#contact')}
              className="w-full mt-2 bg-cream-300 text-baby-blue-600 px-4 py-3 rounded-lg font-medium cursor-pointer whitespace-nowrap"
            >
              立即諮詢
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default BlogNavbar;
